<template>
    <campaign-provider v-slot="{campaign, createProposal, incompleteProposal, isLoading, isCreatingProposal}" style="height: 100%">
        <campaign-view
            :is-loading="isLoading"
            :campaign="campaign"
            :incomplete-proposal="incompleteProposal"
            :is-creating-proposal="isCreatingProposal"
            @create-proposal="createProposal"
        />
    </campaign-provider>
</template>
<script>
    import CampaignProvider from "../providers/CampaignProvider";
    import CampaignView from "../data-views/campaigns/CampaignView";
    import NavigationMenu from "../../../src/components/sections/NavigationMenu";

    export default {
        name: "CampaignRouterView",
        components: {
            NavigationMenu,
            CampaignProvider,
            CampaignView,
        },
    }
</script>
